var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.venta.persona_nombre))]),_c('td',[_vm._v(_vm._s(_vm.venta.persona_apellido))]),_c('td',[_vm._v(_vm._s(_vm.venta.persona_email))]),_c('td',[_vm._v(_vm._s(_vm.venta.persona_celular))]),_c('td',[_vm._v(_vm._s(_vm.venta.menu))])])
}
var staticRenderFns = []

export { render, staticRenderFns }